import React, { MouseEventHandler } from 'react';
import { useHistory } from 'react-router-dom';

import { Alert, AlertProps } from '@ast/magma/components/alert';

import { t } from '@app/core/i18n';

import { useNotifierContext } from './NotifierProvider';

export interface NotifierProps extends React.HTMLProps<HTMLDivElement> {
  readonly alertProps?: Partial<AlertProps>;
}

export const Notifier: React.FC<NotifierProps> = ({
  alertProps,
  ...props
}) => {
  const { alerts, removeAlert } = useNotifierContext();
  const history = useHistory();

  const handleClose = (index: number) => {
    removeAlert(index);
  };

  if (alerts.length === 0) {
    return null;
  }
  const handleCaptureClicks: MouseEventHandler<HTMLDivElement> = (event) => {
    const element = (event?.target as HTMLElement)?.closest('a');
    if (!element) {
      return;
    }

    const originalHref = element.getAttribute('href');

    if (originalHref && new URL(element.href).origin === document.location.origin) {
      event.preventDefault();
      history.push(originalHref);
    }
  };

  return (
    <div {...props}>
      {alerts.map((alert, index) => {
        const {
          title,
          message,
          withHtmlMarkup,
          ...alertOptions
        } = alert;

        return (
          <Alert
            // eslint-disable-next-line react/no-array-index-key
            key={`alert-${index}`}
            showClose={{
              onClose: () => handleClose(index),
              // eslint-disable-next-line i18next/no-literal-string
              'aria-label': t(
                'notifier.alert.close-button.aria-label|Accessibility text for close notification alert button',
                'Close alert',
              ),
            }}
            title={!withHtmlMarkup ? title : ''}
            {...alertOptions}
            {...alertProps}
          >
            {withHtmlMarkup && title ? (
              <div
                onClick={handleCaptureClicks}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            ) : message}
          </Alert>
        );
      })}
    </div>
  );
};
